module.exports = __webpack_public_path__ + "static/img/code.bd7daff0.png";